import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {CouponService} from '../../services/coupon.service';
import {first} from 'rxjs/operators';

declare var swal: any;

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss']
})
export class CouponsComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  coupons: any[];
  @ViewChild(DataTableDirective) private dtElement;

  constructor(
    private couponService: CouponService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.couponService.getDatatable(dataTablesParameters)
          .pipe(first())
          .subscribe(response => {
            this.coupons = response.data;
            callback({
              recordsTotal: response.recordsTotal,
              recordsFiltered: response.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        {data: 'code', searchable: false, orderable: false},
        {data: 'photo', searchable: false, orderable: false},
        {data: 'description', searchable: false, orderable: false},
        {data: 'discount', searchable: false, orderable: false},
        {data: 'start', searchable: false, orderable: false},
        {data: 'end', searchable: false, orderable: false},
        {data: 'status', searchable: false, orderable: false},
        {data: 'limit', searchable: false, orderable: false},
        {data: 'used', searchable: false, orderable: false},
      ]
    };
  }

  private async reloadTable() {
    let dtIntance = await this.dtElement.dtInstance;
    dtIntance.ajax.reload();
  }

  delete(coupon: any): void {
    swal.fire({
      title: '¿Estás seguro que deseas eliminar este registro?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.couponService.delete(coupon.id)
          .pipe(first())
          .subscribe(
            data => {
              this.reloadTable();
              swal.fire('Eliminado', 'El registro ha sido eliminado', 'success');
            },
            error => {
              swal.fire('Error', 'Ha ocurrido un error al intentar eliminar el registro', 'error');
            });
      }
    });
  }

}
